<template>

    <div>
        <watch-statistics-connections link="/api/management/v1/watch_statistics/connections/all"/>
        <watch-statistics-daily class="mt-6" link="/api/management/v1/watch_statistics/daily/all"/>
        <watch-statistics-bars class="mt-6" link="/api/management/v1/watch_statistics/bar_chart/all"/>
    </div>
</template>
<script>

import WatchStatisticsDaily from '@/views/WatchStatistics/WatchStatisticsDaily'
import WatchStatisticsBars from '@/views/WatchStatistics/WatchStatisticsBars'
import WatchStatisticsConnections from '@/views/WatchStatistics/WatchStatisticsConnections'
export default {
    components: { WatchStatisticsConnections, WatchStatisticsBars, WatchStatisticsDaily },
    data(){
        return {
        }
    }
}
</script>
